// @generated by protobuf-ts 2.9.4
// @generated from protobuf file "mlmbox/client/exchanger/exchanger.proto" (package "mlmbox.client.exchanger", syntax proto3)
// tslint:disable
import { Exchanger_Response } from "../../types/exchanger.ts";
import { Exchanger_Request } from "../../types/exchanger.ts";
import { Exchanger_List } from "../../types/exchanger.ts";
import { Empty } from "../../../google/protobuf/empty.ts";
import { Exchanger as Exchanger$ } from "../../types/exchanger.ts";
import { Exchanger_Id } from "../../types/exchanger.ts";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
/**
 * @generated ServiceType for protobuf service mlmbox.client.exchanger.Exchanger
 */
export const Exchanger = new ServiceType("mlmbox.client.exchanger.Exchanger", [
    { name: "Get", options: {}, I: Exchanger_Id, O: Exchanger$ },
    { name: "All", options: {}, I: Empty, O: Exchanger_List },
    { name: "Preview", options: {}, I: Exchanger_Request, O: Exchanger_Response },
    { name: "Verified", options: {}, I: Exchanger_Request, O: Exchanger_Response }
]);
